module.exports = (__webpack_require__(0))(17);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/collections/Collection.js from dll-reference girder_lib
// module id = 71
// module chunks = 0